import service from '@/services/types/codigoActividad'

export const namespaced = true

export const state = () => ({
  list: []
})

export const mutations = {
  LIST: (state, objs) => (state.list = objs.map(obj => ({ ...obj, annotation: `${obj.annotation.substring(0, 75)}` })))
}

export const actions = {
  list: ({ commit, state }, value) =>
    state.list?.length
      ? state.list
      : service
          .list(value)
          .then(
            result =>
              commit('LIST', result) ||
              result.map(obj => ({ ...obj, annotation: `${obj.annotation.substring(0, 75)}${obj.annotation.length > 75 ? '...' : ''}` }))
          )
}
